import React, { useEffect } from 'react';

import SchemaBase from '../../SchemaBase/SchemaBase';

import { useTranslate } from 'react-polyglot';
import { Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';


function SchemaMalePartnerReq(props: SchemaMalePartnerReqProps) {
    const t = useTranslate();
    const params = useParams();


    const [application, setApplication] = React.useState({
        email: '',
        dogName: '',
        regnr: '',
        ownerName: '',
        address: '',
        postalCode: '',
        phoneNumber: '',
        glaucoma: '',
        dwarfism: '',
        hdStatus: '',
        hdIndex: '',
        expectedHeat: '',
        huntPrizes: [] as string[],
        otherWishes: '',
        otherInfo: ''
    });
    
    return (
        <SchemaBase
            title={t('schema.malepartnerreq.title')}
            description={t('schema.malepartnerreq.description')}
            schema={application}
            schemaKey={'malepartnerreq'}
            breedId={params.breedid}
        >
            <div className="malepartnerreq">
                <hr/>
                {/*divider(t('schema.malepartnerreq.email'))*/}
                <div className="inputfield"> {/* Email */}
                    <Form.Label htmlFor="inputEmail">{t('schema.malepartnerreq.email.label')}</Form.Label>
                    <Form.Control
                        id="inputEmail"
                        aria-describedby="emailHelpBlock"
                        value={application.email}
                        onChange={(e) => setApplication({...application, email: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Dog Name */}
                    <Form.Label htmlFor="dogName">{t('schema.malepartnerreq.dogname.label')}</Form.Label>
                    <Form.Control
                        id="inputDogName"
                        aria-describedby="dogNameHelpBlock"
                        value={application.dogName}
                        onChange={(e) => setApplication({...application, dogName: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Regnr */}
                    <Form.Label htmlFor="regnr">{t('schema.malepartnerreq.regnr.label')}</Form.Label>
                    <Form.Control
                        id="inputRegnr"
                        aria-describedby="regnrHelpBlock"
                        value={application.regnr}
                        onChange={(e) => setApplication({...application, regnr: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Owner Name */}
                    <Form.Label htmlFor="ownerName">{t('schema.malepartnerreq.ownername.label')}</Form.Label>
                    <Form.Control
                        id="inputOwnerName"
                        aria-describedby="ownerNameHelpBlock"
                        value={application.ownerName}
                        onChange={(e) => setApplication({...application, ownerName: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Address */}
                    <Form.Label htmlFor="address">{t('schema.malepartnerreq.address.label')}</Form.Label>
                    <Form.Control
                        id="inputAddress"
                        aria-describedby="addressHelpBlock"
                        value={application.address}
                        onChange={(e) => setApplication({...application, address: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Postal Code */}
                    <Form.Label htmlFor="postalCode">{t('schema.malepartnerreq.postalcode.label')}</Form.Label>
                    <Form.Control
                        id="inputPostalCode"
                        aria-describedby="postalCodeHelpBlock"
                        value={application.postalCode}
                        onChange={(e) => setApplication({...application, postalCode: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Phone Number */}
                    <Form.Label htmlFor="phoneNumber">{t('schema.malepartnerreq.phonenumber.label')}</Form.Label>
                    <Form.Control
                        id="inputPhoneNumber"
                        aria-describedby="phoneNumberHelpBlock"
                        value={application.phoneNumber}
                        onChange={(e) => setApplication({...application, phoneNumber: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Glaucoma */}
                    <Form.Label htmlFor="inputGlaucoma">{t('schema.malepartnerreq.glaucoma.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaFree"
                        name={"inputGlaucoma"}
                        label={t('schema.malepartnerreq.glaucoma.options.free')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "free"}
                        onChange={(e) => setApplication({...application, glaucoma: "free"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaCarrier"
                        name={"inputGlaucoma"}
                        label={t('schema.malepartnerreq.glaucoma.options.carrier')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "carrier"}
                        onChange={(e) => setApplication({...application, glaucoma: "carrier"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaAffected"
                        name={"inputGlaucoma"}
                        label={t('schema.malepartnerreq.glaucoma.options.affected')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "affected"}
                        onChange={(e) => setApplication({...application, glaucoma: "affected"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaUnknown"
                        name={"inputGlaucoma"}
                        label={t('schema.malepartnerreq.glaucoma.options.unknown')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "unknown"}
                        onChange={(e) => setApplication({...application, glaucoma: "unknown"})}
                    />
                </div>
                <div className="inputfield"> {/* Dwarfism */}
                    <Form.Label htmlFor="inputDwarfism">{t('schema.malepartnerreq.dwarfism.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfismFree"
                        name={"inputDwarfism"}
                        label={t('schema.malepartnerreq.dwarfism.options.free')}
                        aria-describedby="dwarfismHelpBlock"
                        checked={application.dwarfism == "free"}
                        onChange={(e) => setApplication({...application, dwarfism: "free"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfismCarrier"
                        name={"inputDwarfism"}
                        label={t('schema.malepartnerreq.dwarfism.options.carrier')}
                        aria-describedby="dwarfismHelpBlock"
                        checked={application.dwarfism == "carrier"}
                        onChange={(e) => setApplication({...application, dwarfism: "carrier"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfismAffected"
                        name={"inputDwarfism"}
                        label={t('schema.malepartnerreq.dwarfism.options.affected')}
                        aria-describedby="dwarfismHelpBlock"
                        checked={application.dwarfism == "affected"}
                        onChange={(e) => setApplication({...application, dwarfism: "affected"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfismUnknown"
                        name={"inputDwarfism"}
                        label={t('schema.malepartnerreq.dwarfism.options.unknown')}
                        aria-describedby="dwarfismHelpBlock"
                        checked={application.dwarfism == "unknown"}
                        onChange={(e) => setApplication({...application, dwarfism: "unknown"})}
                    />
                </div>
                <div className="inputfield"> {/* HD Status */}
                    <Form.Label htmlFor="inputHdStatus">{t('schema.malepartnerreq.hdstatus.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputHdStatusA"
                        name={"inputHdStatus"}
                        label={t('schema.malepartnerreq.hdstatus.options.a')}
                        aria-describedby="hdStatusHelpBlock"
                        checked={application.hdStatus == "a"}
                        onChange={(e) => setApplication({...application, hdStatus: "a"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputHdStatusB"
                        name={"inputHdStatus"}
                        label={t('schema.malepartnerreq.hdstatus.options.b')}
                        aria-describedby="hdStatusHelpBlock"
                        checked={application.hdStatus == "b"}
                        onChange={(e) => setApplication({...application, hdStatus: "b"})}
                    />
                </div>
                <div className="inputfield"> {/* HD Index */}
                    <Form.Label htmlFor="inputHdIndex">{t('schema.malepartnerreq.hdindex.label')}</Form.Label>
                    <Form.Control
                        id="inputHdIndex"
                        aria-describedby="hdIndexHelpBlock"
                        value={application.hdIndex}
                        onChange={(e) => setApplication({...application, hdIndex: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Expected Heat */}
                    <Form.Label htmlFor="inputExpectedHeat">{t('schema.malepartnerreq.expectedheat.label')}</Form.Label>
                    <Form.Control
                        id="inputExpectedHeat"
                        aria-describedby="expectedHeatHelpBlock"
                        value={application.expectedHeat}
                        onChange={(e) => setApplication({...application, expectedHeat: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Hunt Prizes */}
                    <Form.Label htmlFor="inputHuntPrizes">{t('schema.malepartnerreq.huntprizes.label')}</Form.Label>
                    <Form.Check
                        type={'checkbox'}
                        id="inputHuntPrizesLoshund"
                        name={"inputHuntPrizes"}
                        label={t('schema.malepartnerreq.huntprizes.options.loshund')}
                        aria-describedby="huntPrizesHelpBlock"
                        checked={application.huntPrizes.includes("loshund")}
                        onChange={(e) => {
                            if (application.huntPrizes.includes("loshund")) {
                                setApplication({...application, huntPrizes: application.huntPrizes.filter((value) => value != "loshund")});
                            } else {
                                setApplication({...application, huntPrizes: [...application.huntPrizes, "loshund"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputHuntPrizesBandhund"
                        name={"inputHuntPrizes"}
                        label={t('schema.malepartnerreq.huntprizes.options.bandhund')}
                        aria-describedby="huntPrizesHelpBlock"
                        checked={application.huntPrizes.includes("bandhund")}
                        onChange={(e) => {
                            if (application.huntPrizes.includes("bandhund")) {
                                setApplication({...application, huntPrizes: application.huntPrizes.filter((value) => value != "bandhund")});
                            } else {
                                setApplication({...application, huntPrizes: [...application.huntPrizes, "bandhund"]});
                            }
                        }}
                    />
                </div>
                <div className="inputfield"> {/* Other Wishes */}
                    <Form.Label htmlFor="inputOtherWishes">{t('schema.malepartnerreq.otherwishes.label')}</Form.Label>
                    <Form.Control
                        id="inputOtherWishes"
                        aria-describedby="otherWishesHelpBlock"
                        value={application.otherWishes}
                        onChange={(e) => setApplication({...application, otherWishes: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Other Info */}
                    <Form.Label htmlFor="inputOtherInfo">{t('schema.malepartnerreq.otherinfo.label')}</Form.Label>
                    <Form.Control
                        id="inputOtherInfo"
                        aria-describedby="otherInfoHelpBlock"
                        value={application.otherInfo}
                        onChange={(e) => setApplication({...application, otherInfo: e.target.value})}
                    />
                </div>
            </div>
        </SchemaBase>
    );
}

class SchemaMalePartnerReqProps {
    
}

export default SchemaMalePartnerReq;